import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { redirect } from 'Helpers/Uri';
import { hashCode } from 'Helpers/String';
import { getFullSlug } from 'Helpers/Photos';
import { getRouteByName } from 'Helpers/Routes';
import { trackEvent } from 'Helpers/Tracking';

import Head from 'Components/helpers/Head';
import Button from 'Components/layout/Button';
import Searchbar from 'Components/layout/Searchbar';
import Tabs from 'Components/layout/Tabs';
import Tab from 'Components/layout/Tab';
import Gallery from 'Components/layout/Gallery';

import trendingPhotos from './data/trending.json';
import curatedAlbums from './data/curated.json';
import userAlbums from './data/albums.json';
import users from './data/users.json';

import { setSelectedPackage } from 'Redux/actions/cart';
import { fetchCreditPackages } from 'Redux/actions/creditPackages';

@connect(
    (state) => ({
        creditPackages: state.creditPackages,
        currentPolicies: state.user.currentPolicies,
    }), { fetchCreditPackages, setSelectedPackage }
)
export default class Market extends React.Component {
    static propTypes = {
        fetchCreditPackages: PropTypes.func.isRequired,
        setSelectedPackage: PropTypes.func.isRequired,
        creditPackages: PropTypes.shape({
            packages: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.string.isRequired,
                    name: PropTypes.string.isRequired,
                    credits: PropTypes.number.isRequired,
                    price: PropTypes.number.isRequired,
                    discountPercentage: PropTypes.number.isRequired
                })
            )
        }),
        params: PropTypes.shape({
            query: PropTypes.string,
            page: PropTypes.string
        }),
        currentPolicies: PropTypes.shape({
            buyCredits: PropTypes.bool.isRequired
        }).isRequired,
    };
    static defaultProps = {};

    constructor(props) {
        super(props);

        //Parse trending photos
        let trendingPhotosArray = trendingPhotos.map(trendingPhoto => {
            return {
                ...trendingPhoto,
                hash: hashCode((new Date()).getHours() + (new Date()).getMinutes() + trendingPhoto.id)
            };
        });

        let trendingPhotosShuffled = trendingPhotosArray.sort((a, b) => {
            return ((a.hash < b.hash) ? -1 : ((a.hash > b.hash) ? 1 : 0));
        });
        trendingPhotosShuffled = trendingPhotosShuffled.slice(0, 40);

        trendingPhotosShuffled = trendingPhotosShuffled.filter(photo => photo && typeof photo.id !== 'undefined');
        let curatedAlbumsPhotos = curatedAlbums.filter(photo => photo && typeof photo.id !== 'undefined');
        let usersPhotos = users.filter(photo => photo && typeof photo.id !== 'undefined');
        let userAlbumsPhotos = userAlbums.filter(photo => photo && typeof photo.id !== 'undefined');

        this.state = {
            trendingPhotos: trendingPhotosShuffled.map(photo => ({
                ...photo,
                href: getRouteByName('singlePhoto', { slug: getFullSlug(photo) }).path
            })),
            curatedAlbums: curatedAlbumsPhotos.map(photo => ({
                ...photo,
                href: getRouteByName('album', { username: photo.username, slug: photo.id }).path
            })),
            users: usersPhotos
                    .filter(photo => photo && photo.user)
                    .map(photo => ({
                    ...photo,
                    href: getRouteByName('user', { username: photo.user.username }).path
                })),
            userAlbums: userAlbumsPhotos.map(photo => ({
                ...photo,
                href: getRouteByName('album', { username: photo.username, slug: photo.id }).path
            })),
        };
    }

    componentDidMount = () => {
        trackEvent('viewContent', {
            contentType: 'market',
            contentName: 'market'
        });

        if (!this.props.creditPackages.packages.length) {
            this.props.fetchCreditPackages();
        }
    }

    setSelectedPackage = selectedPackage => {
        this.props.setSelectedPackage(selectedPackage, 'package', 'market')
            .then(response => {
                redirect(getRouteByName('payment').path);
            });
    }

    render() {
        const { currentPolicies } = this.props;

        return (
            <div className="container-market">
                <Head
                    title={`Market - Authentic, Royalty-Free Stock Photos and Images`}
                    description={`Buy real photos by real people! Launch themed photo missions and choose best content. Build your customized commercial photo library for web or print.`}
                    robots={`index, follow`}
                    canonical={getRouteByName('market').path}
                />
                <section className="section-hero">
                    <div className="centered-content">
                        <h1>
                            Over 40 million creative photos
                            <br />
                            for commercial use
                        </h1>
                        <div className="searchbar-container">
                            <Searchbar query={this.props.params ? this.props.params.query : ''} placeholder="Search high quality images e.g. yellow bird or halloween" />
                        </div>
                    </div>
                    <div className="author-info">
                        <h3>Photo by: <a href={`/users/jordandeckertmedia`}><strong>jordandeckertmedia</strong></a></h3>
                        <Link to={getRouteByName('singlePhoto', { slug: "surfs-tide-9f69309a-1b7c-4e5d-be4c-0ac8ae7cbb7e" }).path}>Buy this Photo</Link>
                    </div>
                </section>
                <section className="section-tabs-gallery">
                    <Tabs>
                        <Tab title="Trending Images" active={true}>
                            <div className="container-fluid">
                                <Gallery
                                    photos={this.state.trendingPhotos}
                                />
                            </div>
                        </Tab>
                        <Tab title="Theme Collections">
                            <div className="container-fluid">
                                <Gallery
                                    overlayType="static"
                                    photos={this.state.curatedAlbums}
                                />
                            </div>
                        </Tab>
                        <Tab title="Featured Photographers">
                            <div className="container-fluid">
                                <Gallery
                                    overlayType="user"
                                    photos={this.state.users}
                                />
                            </div>
                        </Tab>
                        <Tab title="Selected Albums">
                            <div className="container-fluid">
                                <Gallery
                                    overlayType="static"
                                    photos={this.state.userAlbums}
                                />
                            </div>
                        </Tab>
                    </Tabs>
                </section>
                {!currentPolicies.buyCredits ? null :
                    <section className="section-pricing">
                        <div className="container-fluid">
                            <h3 className="pricing-headline">Choose one easy plan</h3>
                            <div className="packages custom-scrollbar">
                                <div className="package-box single">
                                    <h3 className="package-name">Single photo</h3>
                                    <span className="package-price"><sup>$</sup>10.00</span>
                                    <div className="package-features">
                                        <p className="package-feature">Royalty free</p>
                                        <p className="package-feature">Unlimited reproductions</p>
                                        <p className="package-feature">Worldwide usage</p>
                                    </div>
                                </div>
                                {
                                    this.props.creditPackages.packages.map(creditPackage => {
                                        if (creditPackage.credits === 500) {
                                            return (null);
                                        }
                                        return (
                                            <div key={creditPackage.id} className={`package-box ${creditPackage.credits === 200 ? 'highlighted' : ''}`}>
                                                <div className="promo"><span className="promo-text">MOST POPULAR</span></div>
                                                <h3 className="package-name">{creditPackage.worthPhotos} photos</h3>
                                                <span className="package-price"><sup>$</sup>{creditPackage.price.toFixed(2)}</span>
                                                <div className="package-features">
                                                    <p className="package-feature">You save <strong>{creditPackage.discountPercentage}%</strong></p>
                                                </div>
                                                <Button
                                                    layout="full-width"
                                                    onClick={() => this.setSelectedPackage(creditPackage)}
                                                    styleType={creditPackage.credits === 200 ? 'primary' : 'secondary'}
                                                >
                                                    Buy now
                                            </Button>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                            <footer className="pricing-footer">
                                <p>
                                    <strong>Need content that drives engagement and sales?</strong> Try our <Link to={getRouteByName('enterprise').path}>Enterprise solutions</Link> trusted by some of the world's smartest companies. Big and small.
                            </p>
                            </footer>
                        </div>
                    </section>
                }
                <section className="section-boxes">
                    <div className="boxes-bg">
                        <div className="box-bg"></div>
                        <div className="box-bg highlighted"></div>
                    </div>
                    <div className="boxes">
                        <div className="container-fluid">
                            <div className="box box-left">
                                <div className="icon">
                                    <i className="fa fa-camera"></i>
                                </div>
                                <div className="copy">
                                    <p className="subtitle">ARE YOU A PHOTOGRAPHER?</p>
                                    <h2 className="title">Turn your photos into dollars.</h2>
                                </div>
                                <div className="cta">
                                    <Button element="anchor" to={getRouteByName('photographer').path} styleType="secondary">Download our App and Start Uploading</Button>
                                </div>
                            </div>
                            <div className="box box-right">
                                <div className="icon">
                                    <i className="fa fa-picture-o"></i>
                                </div>
                                <div className="copy">
                                    <p className="subtitle">FOR BRANDS AND AGENCIES</p>
                                    <h2 className="title">Brand storytelling content on demand.</h2>
                                </div>
                                <div className="cta">
                                    <Button element="anchor" to={getRouteByName('enterprise').path} styleType="secondary">Check our Solutions for Brands</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/global/Market/index.js